import {normalizeStyle} from '../transform/object';

const {HTMLElement} = globalThis;

/** Setzt Styles eines HTML-Elements. Wenn übergebene Parameter nicht valide, stirbt die Funktion leise.
 * Wenn in den Styles Integer-Werte sind, werden sie zu '...px' geparst.
 * @param {HTMLElement}
 * @param {Object}
 * @alias task.setStyles
 */
export default function setStyles(element, styles)
{
    // "instanceof" erspart Vergleiche auf null
    if (element instanceof HTMLElement && styles instanceof Object)
    {
        Object.assign(element.style, normalizeStyle(styles));
    }
}
